export function getdata() {
    var obj = {
        headlist: [
            {
                name: "待办事项"
            }
            ,
            {
                name: "我的提醒"
            },
        ]
    }
    return obj
}
